import React, { useEffect, useState } from "react";
import { WithdrawState } from "../../payments/PaymentsReducer";
import { t } from "../../i18n";
import "../Withdraw.scss"
import { connect } from "react-redux";
import { AppState } from "../../RootReducer";
import { CurrencyDefinition, PaymentMethod, PaymentResultCode, RequestWithdrawResponse, WithdrawContext } from "../../http/protocol";
import { BrandA } from "../buttons/buttons";
import { PriorityType } from "../../http/Types";
import withdrawSuccessImage from '../../assets/payments/icons/withdrawIcons.png'
import withdrawErrorImage from '../../assets/payments/icons/withdrawErr.png'
import { getActiveCurrency } from "../../selectors/user-selectors";
import { getCurrencyDefinitions, getPreferredFiatExchange } from "../../selectors/settings-selectors";
import { getCurrencyName, hasFiatExchangeAmount, toFiatAmount } from "../../currency/currency-utils";
import { Link } from "react-router-dom";


interface Props {
    withdraw: WithdrawState;
    onClick: () => void;
    recipientAddress?: string;
    amount?: string;
    currency?: string;
    confirmedStatus?: boolean;
    currencies?: Array<CurrencyDefinition>;
    activeMethod?: PaymentMethod;
    priority?: PriorityType;
    withdrawContext?: WithdrawContext;
    /** Override the default title. Translation key. */
    overrideTitleKey?: string;
    /** Override the default text. Translation key. */
    overrideTextKey?: string
    isCrypto?: boolean;
    currencyDefinitions?: CurrencyDefinition[];
    preferredExchangeCurrency?: string;
}



const WithdrawResponseView = (props: Props) => {
    const response: RequestWithdrawResponse | undefined = props.withdraw.withdrawResponse;
    const responseStatus: boolean = response?.result === PaymentResultCode.OK;

    let fiatAmount;
    if (props.currency && props.amount && hasFiatExchangeAmount(props.currency, props.preferredExchangeCurrency, props.currencyDefinitions)) {
        fiatAmount = toFiatAmount(props.currency, parseFloat(props.amount), props.preferredExchangeCurrency, props.currencyDefinitions)
    }

    return (
        <div className={"withdraw-response-container"}>
            {props.withdraw && (
                <>

                    {/* -------- SUCCESS -------- */}
                    {responseStatus && (
                        <div className="withdraw-response-outer-container">
                            <div className="confirm-withdraw-header">
                                <div className={"withdraw-title"}>
                                    {
                                        props.overrideTitleKey === undefined ? <span className="title">{t('payments.withdrawResponseTitle')}</span> : <span className="title">{t(props.overrideTitleKey!)}</span>
                                    }
                                </div>
                                <div className={"withdraw-icon"}>
                                    <img src={withdrawSuccessImage} alt="wallet withdraw icon" />
                                </div>
                            </div>
                            <div className={"withdraw-response-inner-container"}>
                                {props.isCrypto ? (
                                    <div className={"withdraw-title"}>
                                        {props.currency && props.amount && (
                                            <p>
                                                {t("payments.withdrawResponseCrypto", {
                                                    amount: props.amount,
                                                    currency: getCurrencyName({ currencies: props.currencies || [], currency: props.currency }),
                                                    euroAmount: fiatAmount
                                                })}
                                                <Link to={"/account/transactions/wallet"} className={"transaction-link"} onClick={props.onClick}>{t("payments.withdrawalResponseLink")}</Link>
                                            </p>
                                        )}
                                    </div>
                                ) : (
                                    <div className={"withdraw-title"}>
                                        {props.currency && props.amount && (
                                            <p>
                                                {t("payments.withdrawResponseFiat", {
                                                    amount: props.amount,
                                                    currency: getCurrencyName({ currencies: props.currencies || [], currency: props.currency }),
                                                })}
                                                <Link to={"/account/transactions/wallet"} className={"transaction-link"} onClick={props.onClick}>{t("payments.withdrawalResponseLink")}</Link>
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="withdraw-button-container">
                                <BrandA className={"btn btn-cta"} onClick={props.onClick}>{t('rewards.claim-dialog.close')}</BrandA>
                            </div>
                        </div>


                    )}

                    {/* -------- ERROR -------- */}
                    {!responseStatus && (
                        <div className="withdraw-response-outer-container">
                            <div className="confirm-withdraw-header">
                                <div className={"withdraw-title"}>
                                    {
                                        props.overrideTitleKey === undefined ? <span className="title">{t('payments.withdrawResponseErrorTitle')}</span> : <span className="title">{t(props.overrideTitleKey!)}</span>
                                    }
                                </div>
                                <div className={"withdraw-icon"}>
                                    <img src={withdrawErrorImage} alt="wallet withdraw icon" />
                                </div>
                            </div>
                            <div className={"withdraw-response-inner-container"}>
                                <div className={"withdraw-title"}>
                                    <p>
                                        {t("payments.withdrawResponseError")}
                                    </p>
                                </div>
                                <div className={"withdraw-title"}>
                                    <p>
                                        {t("payments.withdrawResponseErrorStatus")}
                                        "{response?.result}"
                                    </p>
                                </div>
                            </div>
                            <div className="withdraw-button-container">
                                <BrandA className={"btn btn-cta"} onClick={props.onClick}>{t('rewards.claim-dialog.close')}</BrandA>
                            </div>
                        </div>
                    )}
                </>

            )}
        </div>
    )
};

const mapStateToProps = (app: AppState) => {
    return {
        priority: app.payments.withdraw.priority,
        withdrawContext: app.payments.withdraw.withdrawContext,
        withdraw: app.payments.withdraw,
        activeMethod: app.payments.withdraw.activeMethod,
        currency: app.payments.withdraw.activeCurrency,
        amount: app.payments.withdraw.amount,
        recipientAddress: app.payments.withdraw.recipientAddress,
        currencies: app.user.user != undefined ? app.user.user.currencies : undefined,
        isCrypto: getActiveCurrency(app)?.cryptoCurrency,
        currencyDefinitions: getCurrencyDefinitions(app),
        preferredExchangeCurrency: getPreferredFiatExchange(app)


    }
};

export default connect(mapStateToProps)(WithdrawResponseView);




